/**
 * シングルモードのステージ選択オーバーレイ。
 *
 * セットアップ画面（src/ui/setup.js）の DOM 構築パターンに倣う。ステージ
 * 一覧（タイトル・説明・クリア済みチェック）とタイトルへ戻るボタンを描画し、
 * ステージがクリックされたら onStart(stage) を呼ぶ。stage.tier（難易度名）が
 * 直前のステージと変わる位置に難易度見出しを挟む。
 *
 * クリア状況は show() のたびに isCleared(id) を読み直して反映する（対局に
 * 勝ってステージ選択へ戻ると即座にチェックが付く）。ルール・localStorage の
 * 責務はここには持たない（呼び出し側 = main.js が注入する）。
 *
 * hooks.onSelect (任意) は選択クリックごとに呼ばれ、main.js が 'select' SE に
 * つなぐ。
 */

export function createStageSelectScreen(root, stages, onStart, onBack, hooks = {}) {
  const onSelect = () => hooks.onSelect?.();
  const isCleared = hooks.isCleared ?? (() => false);

  root.innerHTML = '';
  const panel = document.createElement('div');
  panel.id = 'stage-panel';

  const title = document.createElement('h1');
  title.textContent = 'シングルモード — ステージ選択';
  panel.appendChild(title);

  const list = document.createElement('div');
  list.className = 'stage-list';
  panel.appendChild(list);

  // 各ステージのチェック要素を保持し、show() 時に付け外しする
  const checkEls = new Map();

  let prevTier = null;
  stages.forEach((stage, i) => {
    if (stage.tier && stage.tier !== prevTier) {
      const heading = document.createElement('div');
      heading.className = 'stage-tier-heading';
      heading.textContent = stage.tier;
      list.appendChild(heading);
      prevTier = stage.tier;
    }

    const card = document.createElement('button');
    card.type = 'button';
    card.className = 'stage-card';

    const num = document.createElement('span');
    num.className = 'stage-num';
    num.textContent = String(i + 1);

    const text = document.createElement('span');
    text.className = 'stage-text';
    const name = document.createElement('span');
    name.className = 'stage-name';
    name.textContent = stage.title;
    const desc = document.createElement('span');
    desc.className = 'stage-desc';
    desc.textContent = stage.description;
    text.appendChild(name);
    text.appendChild(desc);

    const check = document.createElement('span');
    check.className = 'stage-check hidden';
    check.textContent = '✓ クリア';
    check.setAttribute('aria-hidden', 'true');
    checkEls.set(stage.id, check);

    card.appendChild(num);
    card.appendChild(text);
    card.appendChild(check);
    card.addEventListener('click', () => {
      onSelect();
      onStart(stage);
    });
    list.appendChild(card);
  });

  const backBtn = document.createElement('button');
  backBtn.type = 'button';
  backBtn.id = 'stage-back-btn';
  backBtn.textContent = 'タイトルへ戻る';
  backBtn.addEventListener('click', () => {
    onSelect();
    onBack();
  });
  panel.appendChild(backBtn);

  root.appendChild(panel);

  function syncChecks() {
    for (const [id, el] of checkEls) {
      el.classList.toggle('hidden', !isCleared(id));
    }
  }

  return {
    show() {
      syncChecks(); // クリア状況を最新化
      root.classList.remove('hidden');
    },
    hide() {
      root.classList.add('hidden');
    },
  };
}
